import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from '../helpers/Helpers';
import withForm from '../layouts/withForm';
const Security2faApplicationAuthentication = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [roles, setRoles] = useState({});   
    const [rolesArray, setRolesArray] = useState([]);   
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-roles",
                    method: 'GET'
                });
        
                // Save to localStorage
                localStorage.setItem("plusRoles", JSON.stringify(results));
        
                // Update state
                setRoles(results);
            } catch (error) {
                console.error("Error fetching roles:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedRoles = localStorage.getItem("plusRoles");
        if (storedRoles) {
            setRoles(JSON.parse(storedRoles));
        } else {
            fetchRoles();
        }
    }, []);
    
    useEffect(() => {
        const tempArray = Object.entries(roles).length && Object.entries(roles).map(([code, { name, count }]) => ({
            value: name, // name
            code: code, // Use the key as the code
        }));
        setRolesArray(tempArray)
    }, [roles])
    const [isEncrypted, setIsEncrypted] = useState(0);
    const [isEncryptedReset, setIsEncryptedReset] = useState(0);
    const [isEncryptedLoaded, setIsEncryptedLoaded] = useState(false);
    useEffect(() => {
        setIsEncryptedLoaded(false);
        const fetchEncrypted = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-enable-encryption-database-keys",
                    method: 'GET'
                });
        
                // Update state
                setIsEncrypted(results);
                setIsEncryptedLoaded(true);
        
            } catch (error) {
                console.error("Error fetching encryption database key:", error);
            }
        };       
        fetchEncrypted();
    }, []);

    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const [isEncryptedDone, setIsEncryptedDone] = useState(false);
    const encryptDbKeys = async () => {
        setProcessing(true);
        setProcessingRing(true);
        try {
            const result = await formDataPost("ultimate_security_enable_encryption_database_keys", {});
            if (result === true) {
                setProcessingRing(false);
                setProcessingTick(true)
                
                setTimeout(()=> {
                    setProcessingTick(false)
                    setProcessing(false)
                    setIsEncryptedDone(true)
                },1000)
            }
                
        } catch (error) {
            // console.log(error.message);
        } finally {
            setProcessing(false);
            setProcessingRing(false)
        }
    }

    return (
        <>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("2FA Authenticator Applications", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Two-factor authentication enables users to log in with a second authentication method beyond their email and password. It is one of the most effective ways to prevent account theft.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable two-Factor authentication.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Two-Factor Authenticator Applications", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.2fa_authentication.application_authentication.2fa_application_authentication_enable"
                                    checked={settingData?.security?.['2fa_authentication']?.['application_authentication']?.['2fa_application_authentication_enable']} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable for:", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-start">
                                    <Hint position="top" content={__("No Hint", "ultimate-security")}/>    
                                    {
                                        rolesArray.length &&                                                                     
                                        <TagInput 
                                            name='security.2fa_authentication.application_authentication.2fa_application_authentication_enable_for'
                                            type='role' 
                                            whitelist={rolesArray}
                                            initialTags={settingData?.security?.['2fa_authentication']?.['application_authentication']?.['2fa_application_authentication_enable_for']} 
                                            handleChange={handleChange} 
                                        />
                                    }   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Advanced settings", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Choose which algorithm for One Time Passwords you want to use.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Select 2FA algorithm based on your requirement", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.security?.['2fa_authentication']?.['application_authentication']?.['2fa_application_authentication_type']} 
                                        onChange={(e) => handleChange('security.2fa_authentication.application_authentication.2fa_application_authentication_type', e.target.value)}
                                    >                                        
                                        <option value="TOTP">{__("TOTP (time based - most common algorithm; used by Google Authenticator)", "ultimate-security")}</option>
                                        <option value="HOTP">{__("HOTP (event based)", "ultimate-security")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("XMLRPC requests", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("XML-RPC is a WordPress feature that allows other computers to communicate with your WordPress site. For instance, it enables apps on devices like tablets to let you blog directly from the app instead of using the WordPress dashboard.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable XMLRPC request", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.security?.['2fa_authentication']?.['application_authentication']?.['xmlrpc_requests']} 
                                        onChange={(e) => handleChange('security.2fa_authentication.application_authentication.xmlrpc_requests', e.target.value)}
                                    >                                        
                                        <option value="not-require">{__("Do not require 2FA over XMLRPC", "ultimate-security")}</option>
                                        <option value="require">{__("Do require 2FA over XMLRPC", "ultimate-security")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Encrypt keys in database", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Keep in mind, that this feature cannot be turned off. However, there is no technical reason why this should discourage you from using it.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                {/* {console.log('isEncryptedLoaded:', isEncryptedLoaded, ', isEncrypted:', isEncrypted, ', isEncryptedDone:', isEncryptedDone)} */}
                                {
                                    isEncryptedLoaded 
                                    ?
                                        isEncrypted === "1" || isEncryptedDone !== false
                                        ? 
                                            <div className="title-group d-flex align-items-center ">
                                                <Hint content={__("Enable encryption", "ultimate-security")}/>
                                                <div>{__("Encryption enabled.", "ultimate-security")}</div>
                                            </div>
                                        :
                                            <div className="title-group d-flex align-items-center ">
                                                <Hint content={__("Encrypt Database Keys", "ultimate-security")}/>
                                                <div className="d-flex align-items-center gap-2"> 
                                                    <button 
                                                        type="button" 
                                                        className="button button-primary" 
                                                        onClick={encryptDbKeys} // encryptDbKeys, handleAction
                                                        disabled={processing || isEncryptedDone}
                                                    >
                                                        {
                                                            processing ? __( "Processing...", "ultimate-security" ) : __( "Encrypt Database Keys", "ultimate-security" )
                                                        }
                                                    </button>
                                                    {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                                    {processingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}

                                                </div>
                                            </div>
                                    
                                    : 'Loading...'
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(Security2faApplicationAuthentication, 'security.2fa_authentication.application_authentication');